<template>
  <el-dialog
    title
    :visible.sync="show"
    :close-on-click-modal="false"
    width="550px"
    class="edit-modal"
    :append-to-body="true"
    @close="onChange"
  >
    <div slot="title">
      {{ drawRow.type === 'add' ? $t('shop-site::google::add_button') : $t('shop-site::google::edit_button') }}
      <!-- <span v-show="drawRow.type === 'add'">
        <i class="icon-a-01wenhao iconfont-el"></i>
        <el-button type="text" @click="toGuider" style="font-size:12px;">
          如何获取Facebook账号ID及Token？
        </el-button>
      </span> -->
    </div>

    <el-form class="user-body" ref="form" :model="params" :rules="rules" label-width="130px">
      <el-form-item :label="$t('shop-site::google::form_managerId') + '：'" prop="customerId">
        <el-input
          :placeholder="$t('shop-site::google::placeholder_managerId')"
          class="input-item"
          v-model.trim="params.customerId"
        ></el-input>
      </el-form-item>
      <el-form-item :label="$t('shop-site::google::form_token') + '：'" prop="developerToken">
        <el-input
          :placeholder="$t('shop-site::google::placeholder_token')"
          class="input-item"
          v-model.trim="params.developerToken"
        ></el-input>
      </el-form-item>
      <el-form-item :label="$t('shop-site::google::form_serverId') + '：'" prop="clientId">
        <el-input
          :placeholder="$t('shop-site::google::placeholder_serverId')"
          class="input-item"
          v-model.trim="params.clientId"
        ></el-input>
      </el-form-item>
      <el-form-item :label="$t('shop-site::google::form_serverSecret') + '：'" prop="clientSecret">
        <el-input
          :placeholder="$t('shop-site::google::placeholder_serverSecret')"
          class="input-item"
          v-model.trim="params.clientSecret"
          rows="3"
          type="textarea"
        ></el-input>
      </el-form-item>
      <!-- <el-form-item label="RefreshToken" prop="refreshToken">
        <el-input
          :placeholder="$t('shop-site::google::placeholder_refreshToken')"
          class="input-item"
          v-model.trim="params.refreshToken"
          type="textarea"
          rows="3"
        ></el-input>
      </el-form-item>
      <el-form-item label="ReleaseStatus：" prop="releaseStatus">
        <el-select
          :popper-append-to-body="false"
          v-model="params.releaseStatus"
          :placeholder="$t('shop-site::google::placeholder_releaseStatus')"
        >
          <el-option :label="$t('shop-site::google::form_unofficial')" :value="0"></el-option>
          <el-option :label="$t('shop-site::google::form_official')" :value="1"></el-option>
        </el-select>
      </el-form-item> -->
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="onChange">{{ $t('system::common::btn::cancel') }}</el-button>
      <el-button type="primary" @click="onSave" :loading="saveLoading">
        {{ $t('system::common::btn::confirm') }}
      </el-button>
    </div>
  </el-dialog>
</template>
<script>
import { setGoogleManagerAccount } from '@/server/marketing.js'
export default {
  name: 'edit-modal',
  model: {
    prop: 'visible',
    event: 'change',
  },
  props: {
    visible: {
      default: false,
    },
    drawRow: {
      default: () => {},
    },
  },
  watch: {
    visible(bool) {
      this.show = bool
      const data = this.drawRow
      if (data.type === 'add') {
        this.params = {
          customerId: '',
          id: null,
          developerToken: '',
          clientId: '',
          clientSecret: '',
          refreshToken: '',
          releaseStatus: 1,
        }
      } else {
        this.params = {
          customerId: data.item.customerId,
          id: data.item.id,
          developerToken: data.item.developerToken,
          clientId: data.item.clientId,
          clientSecret: data.item.clientSecret,
          refreshToken: data.item.refreshToken,
          releaseStatus: Number(data.item.releaseStatus),
        }
      }

      this.$nextTick(() => this.$refs.form.clearValidate())
    },
    drawRow: {
      handler: function (data) {},
      deep: true,
    },
  },
  data() {
    return {
      saveLoading: false,
      rules: {
        releaseStatus: [
          { required: true, message: this.$t('shop-site::google::placeholder_releaseStatus'), trigger: 'change' },
        ],
        customerId: [{ required: true, message: this.$t('shop-site::google::placeholder_managerId'), trigger: 'blur' }],
        developerToken: [{ required: true, message: this.$t('shop-site::google::placeholder_token'), trigger: 'blur' }],
        clientId: [{ required: true, message: this.$t('shop-site::google::placeholder_serverId'), trigger: 'blur' }],
        clientSecret: [
          { required: true, message: this.$t('shop-site::google::placeholder_serverSecret'), trigger: 'blur' },
        ],
        refreshToken: [
          { required: true, message: this.$t('shop-site::google::placeholder_refreshToken'), trigger: 'blur' },
        ],
      },
      show: false,
      params: {},
    }
  },
  mounted() {},
  methods: {
    toGuider() {
      window.open('https://docs.qq.com/doc/DTFZnd1dBTkFuWGZS', '_blank')
    },
    onChange() {
      this.$emit('change', false)
    },
    onSave() {
      this.$refs['form'].validate(async valid => {
        if (valid) {
          this.saveLoading = true
          let params = {
            ...this.params,
          }
          if (this.drawRow.type === 'add') {
            delete params.id
          }
          const { data } = await setGoogleManagerAccount(params)
          if (data.code === this.$code) {
            if (this.drawRow.type === 'add') {
              await this.$store.dispatch('getBindData')
              if (data.data) {
                window.location.href = data.data
              }
            } else {
              this.$message.success(this.$t('system::tip::control_success'))
              this.$emit('save')
              this.$emit('change', false)
            }
          }
          this.saveLoading = false
        }
      })
    },
  },
}
</script>
<style lang="scss" scoped>
.edit-modal {
  .user-body {
    .input-item {
      width: 100%;
    }
  }
  .check-info {
    margin-bottom: 10px;
  }
  .tip-info {
    color: $--color-info;
  }
}
.empty-wrap {
  padding: 50px;
  display: flex;
  align-items: center;
  justify-content: center;
  line-height: 1;
}
.icon-a-01wenhao {
  margin-left: 5px;
  font-size: 12px;
}
.iconadd {
  margin-left: 5px;
  font-size: 16px;
  color: #dcdfe6;
  cursor: pointer;
  line-height: 31px;
}
</style>
